import axios from 'axios';

// En producción (mismo servidor) usa URL relativa "".
// En desarrollo pasar REACT_APP_API_URL=http://localhost:3001 via .env.development
const API_BASE = process.env.REACT_APP_API_URL ?? '';

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('saturnpro_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // Prepend /api to all relative paths so /clientes → /api/clientes
  if (config.url && !config.url.startsWith('/api') && !config.url.startsWith('http')) {
    config.url = '/api' + config.url;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // 401 = token inválido o expirado → cerrar sesión
    // 403 NO cierra sesión: puede ser licencia vencida (LicenciaGuard la muestra),
    // permisos insuficientes, o empresa sin asignar — el componente o LicenciaContext
    // ya manejan esos casos con su propio catch.
    if (error.response?.status === 401) {
      localStorage.removeItem('saturnpro_token');
      localStorage.removeItem('saturnpro_usuario');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
